import type { TextNodeType } from "../../../FormattedText/FormattedText";
import FormattedText from "../../../FormattedText/FormattedText";
import type { MyCashState } from "../../ListingPageV2.types";
import { Cta, Icon, Row, TextCol, Wrap } from "./Styles";

interface MyCashDataState {
  icon?: string;
  ctaText?: string;
  title?: TextNodeType;
}

interface MyCashPersuasionProps {
  myCashData?: {
    unApplied?: MyCashDataState;
    loggedOut?: MyCashDataState;
    applied?: MyCashDataState;
  };
  myCashState?: MyCashState;
  onMyCashPress?: () => void;
}

export const MyCashPersuasion = ({
  myCashData,
  myCashState = "unApplied",
  onMyCashPress,
}: MyCashPersuasionProps) => {
  const current =
    myCashData?.[myCashState] ??
    (myCashState === "applied" ? myCashData?.unApplied : undefined);
  if (!current?.title) return null;

  const ctaText = myCashData?.[myCashState]?.ctaText;

  return (
    <Wrap>
      <Row>
        {current.icon && <Icon src={current.icon} alt="myCash" />}
        {current.title && (
          <TextCol>
            <FormattedText value={current.title} />
          </TextCol>
        )}
        {ctaText && (
          <Cta type="button" onClick={onMyCashPress}>
            {ctaText}
          </Cta>
        )}
      </Row>
    </Wrap>
  );
};
